import { handleFilters } from "util/filters";
import Page from "webPage/Page";

Page.register([
    '/training-courses/?',
    '/training-courses/page/([0-9]+)/?',
], () => {
    handleFilters();
});

